import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField'
import Button from "@material-ui/core/Button";
import SearchIcon from "@material-ui/icons/Search"
import axios from 'axios';
import MUIDataTable from "mui-datatables";
import {bffUrl, urlConfig} from './config.js'
import Card from '@material-ui/core/Card';
import CircularProgress from '@material-ui/core/CircularProgress';
import {withSnackbar} from 'notistack';

const styles = theme => ({
    container: {
        position: 'relative',
    },
    progress: {
        margin: theme.spacing(2),
    },
});

const chunkSize = 50;

class ThumbnailPrint extends Component {

    state = {
        playlistId: '',
        cid: '',
        thumbnailData: [],
        showLoading: false
    };

    handleChange = element => event => {
        this.setState({
            [element]: event.target.value,
        }, function () {

        });
    };

    chunk = (arr, chunkSize) => {
        var R = [];
        for (var i = 0, len = arr.length; i < len; i += chunkSize)
            R.push(arr.slice(i, i + chunkSize));
        return R;
    };

    findThumbnails = () => {
        this.setState({
            showLoading: true,
            thumbnailData: []
        });

        var arrayschunkingCids = [];
        var arrayOfCid = [];

        var url = "";

        var getCidBaseUrl = `${bffUrl}/thumbnail/getCids?pccs=&playlistIds=${this.state.playlistId}&contextIds=&cids=${this.state.cid}`;

        const getCidInstance = axios.create({
            baseURL: getCidBaseUrl,
            timeout: 120000,
        });

        getCidInstance.get()
            .then((res) => {
                if (res.status === 200) {
                    if (res) {
                        if (res.data) {
                            if (res.data.entity) {
                                if (res.data.entity.contentInputs) {
                                    if (res.data.entity.contentInputs.cids) {
                                        res.data.entity.contentInputs.cids.forEach(cid => {
                                            arrayOfCid.push(cid);
                                        })
                                    }
                                }

                                if (res.data.entity.contentResults) {
                                    res.data.entity.contentResults.forEach(contentResult => {
                                        arrayOfCid.push(contentResult.cid);
                                    })
                                }

                                if (arrayOfCid.length > 0) {
                                    arrayschunkingCids = this.chunk(arrayOfCid, chunkSize);

                                    let rows = [];
                                    this.getThumbnailsForChunks(arrayschunkingCids).then((thumbRows) => {
                                        rows = thumbRows;
                                        this.setState({
                                            thumbnailData: rows,
                                            showLoading: false
                                        })
                                    })
                                } else {
                                    this.props.enqueueSnackbar('Failed to Get Thumbnail.', {
                                        variant: 'warning', anchorOrigin: {
                                            vertical: 'bottom',
                                            horizontal: 'center',
                                        }
                                    });
                                    this.setState({
                                        showLoading: false,
                                        playlistId: '',
                                        cid: ''
                                    })
                                }

                            } else {
                                this.props.enqueueSnackbar('Failed to Get Thumbnail.', {
                                    variant: 'warning', anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'center',
                                    }
                                });
                                this.setState({
                                    showLoading: false,
                                    playlistId: '',
                                    cid: ''
                                })
                            }
                        } else {
                            this.props.enqueueSnackbar('Failed to Get Thumbnail.', {
                                variant: 'warning', anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }
                            });
                            this.setState({
                                showLoading: false,
                                playlistId: '',
                                cid: ''
                            })
                        }
                    } else {
                        this.props.enqueueSnackbar('Failed to Get Thumbnail.', {
                            variant: 'warning', anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'center',
                            }
                        });
                        this.setState({
                            showLoading: false,
                            playlistId: '',
                            cid: ''
                        })
                    }
                } else {
                    this.props.enqueueSnackbar('Failed to Get Thumbnail.', {
                        variant: 'warning', anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'center',
                        }
                    });
                    this.setState({
                        showLoading: false,
                        playlistId: '',
                        cid: ''
                    })
                }

            })
            .catch(err => {
                console.log(err);
            })
        ;
    };


    getThumbnailsForChunks = async (arrayschunkingCids) => {
        const captionStyle = {};
        var rows = [];
        if (arrayschunkingCids.length > 0) {

            for (let i = 0; i < arrayschunkingCids.length; i++) {
                let arraychunkingCid = arrayschunkingCids[i];

                var cidString = arraychunkingCid.join();
                var getThumbnailsBaseUrl = `${bffUrl}/thumbnail/getThumbnails?cids=${cidString}`;

                const getThumbnailsInstance = axios.create({
                    baseURL: getThumbnailsBaseUrl,
                    timeout: 120000,
                });

                await getThumbnailsInstance.get()
                    .then(res => {
                        var flatResponse = [];

                        if (res.data) {
                            if (res.data.entity) {
                                Object.entries(res.data.entity).forEach(([key, value]) => {
                                    var MP27X40Array = [];
                                    var WT16X9Array = [];
                                    var T16X9Array = [];
                                    var WT4X3Array = [];
                                    var T4X3Array = [];
                                    var currentRow = [];
                                    let width = 800;
                                    let height = 600;
                                    let isDefaultTrue = false;
                                    let maxVersion = 0;
                                    let maxVersionTcid = "";

                                    let thumbnailWidth = 120;
                                    let thumbnailHeight = 90;

                                    if (value) {
                                        value.forEach(thumbnail => {
                                            if (thumbnail.ratio === "WT4X3") {
                                                width = 800;
                                                height = 600;
                                                thumbnailWidth = 120;
                                                thumbnailHeight = 90;
                                                isDefaultTrue = false;
                                                maxVersion = 0;
                                                maxVersionTcid = "";
                                                let widthAndHeight = `${width}x${height}`;
                                                const thumbnailContainerCardStyleDefault = {
                                                    width: thumbnailWidth,
                                                    height: thumbnailHeight + 40,
                                                    marginLeft: '12px',
                                                    marginTop: '12px',
                                                    border: 'solid',
                                                    borderColor: 'lightgreen'
                                                };

                                                if (thumbnail.versions) {
                                                    thumbnail.versions.forEach(version => {
                                                        if (version.default) {

                                                            isDefaultTrue = true;
                                                            if (version.version >= maxVersion) {
                                                                maxVersion = version.version;
                                                                maxVersionTcid = version.tcid;
                                                            }

                                                            let card = (
                                                                <Card style={thumbnailContainerCardStyleDefault}>
                                                                    <a href={`${urlConfig.thumbnailUrlBase}?cid=${version.tcid}&t=thumb${widthAndHeight}&v=${version.version}`}
                                                                       target="_blank" rel="noopener noreferrer">
                                                                        <img id={version.tcid} height={thumbnailHeight}
                                                                             width={thumbnailWidth}
                                                                             alt={`tcid=${version.tcid}`}
                                                                             src={`${urlConfig.thumbnailUrlBase}?cid=${version.tcid}&t=thumb${widthAndHeight}&v=${version.version}`}>
                                                                        </img>
                                                                    </a>
                                                                    <Typography variant={'caption'}
                                                                                style={captionStyle}>
                                                                        {`${thumbnail.language}, v${version.version} `}
                                                                    </Typography>
                                                                </Card>
                                                            );

                                                            WT4X3Array.push(card)

                                                        } else {
                                                            if (version.version >= maxVersion) {
                                                                maxVersion = version.version;
                                                                maxVersionTcid = version.tcid;
                                                            }
                                                        }
                                                    });

                                                    if (isDefaultTrue === false) {
                                                        let card = (
                                                            <Card style={thumbnailContainerCardStyleDefault}>
                                                                <a href={`${urlConfig.thumbnailUrlBase}?cid=${maxVersionTcid}&t=thumb${widthAndHeight}&v=${maxVersion}`}
                                                                   target="_blank" rel="noopener noreferrer">
                                                                    <img id={maxVersionTcid} height={thumbnailHeight}
                                                                         width={thumbnailWidth}
                                                                         alt={`tcid=${maxVersionTcid}`}
                                                                         src={`${urlConfig.thumbnailUrlBase}?cid=${maxVersionTcid}&t=thumb${widthAndHeight}&v=${maxVersion}`}>
                                                                    </img>
                                                                </a>
                                                                <Typography variant={'caption'} style={captionStyle}>
                                                                    {`${thumbnail.language}, v${maxVersion} `}
                                                                </Typography>
                                                            </Card>
                                                        );

                                                        WT4X3Array.push(card)

                                                    }
                                                }
                                            }

                                            if (thumbnail.ratio === "T4X3") {
                                                width = 800;
                                                height = 600;
                                                thumbnailWidth = 120;
                                                thumbnailHeight = 90;
                                                isDefaultTrue = false;
                                                maxVersion = 0;
                                                maxVersionTcid = "";
                                                let widthAndHeight = `${width}x${height}`;
                                                const thumbnailContainerCardStyleDefault = {
                                                    width: thumbnailWidth,
                                                    height: thumbnailHeight + 40,
                                                    marginLeft: '12px',
                                                    marginTop: '12px',
                                                    border: 'solid',
                                                    borderColor: 'lightgreen'
                                                };

                                                if (thumbnail.versions) {
                                                    thumbnail.versions.forEach(version => {
                                                        if (version.default) {

                                                            isDefaultTrue = true;
                                                            if (version.version >= maxVersion) {
                                                                maxVersion = version.version;
                                                                maxVersionTcid = version.tcid;
                                                            }

                                                            let card = (
                                                                <Card style={thumbnailContainerCardStyleDefault}>
                                                                    <a href={`${urlConfig.thumbnailUrlBase}?cid=${version.tcid}&t=thumb${widthAndHeight}&v=${version.version}`}
                                                                       target="_blank"
                                                                       rel="noopener noreferrer">
                                                                        <img id={version.tcid} height={thumbnailHeight}
                                                                             width={thumbnailWidth}
                                                                             alt={`tcid=${version.tcid}`}
                                                                             src={`${urlConfig.thumbnailUrlBase}?cid=${version.tcid}&t=thumb${widthAndHeight}&v=${version.version}`}>
                                                                        </img>
                                                                    </a>
                                                                    <Typography variant={'caption'}
                                                                                style={captionStyle}>
                                                                        {`${thumbnail.language}, v${version.version} `}
                                                                    </Typography>
                                                                </Card>
                                                            );

                                                            T4X3Array.push(card)

                                                        } else {
                                                            if (version.version >= maxVersion) {
                                                                maxVersion = version.version;
                                                                maxVersionTcid = version.tcid;
                                                            }
                                                        }
                                                    });
                                                    if (isDefaultTrue === false) {
                                                        console.log("maxversionid in false :: " + maxVersionTcid);
                                                        let card = (
                                                            <Card style={thumbnailContainerCardStyleDefault}>
                                                                <a href={`${urlConfig.thumbnailUrlBase}?cid=${maxVersionTcid}&t=thumb${widthAndHeight}&v=${maxVersion}`}
                                                                   target="_blank" rel="noopener noreferrer">
                                                                    <img id={maxVersionTcid} height={thumbnailHeight}
                                                                         width={thumbnailWidth}
                                                                         alt={`tcid=${maxVersionTcid}`}
                                                                         src={`${urlConfig.thumbnailUrlBase}?cid=${maxVersionTcid}&t=thumb${widthAndHeight}&v=${maxVersion}`}>
                                                                    </img>
                                                                </a>
                                                                <Typography variant={'caption'} style={captionStyle}>
                                                                    {`${thumbnail.language}, v${maxVersion} `}
                                                                </Typography>
                                                            </Card>
                                                        );

                                                        T4X3Array.push(card)

                                                    }
                                                }
                                            }

                                            if (thumbnail.ratio === "MP27X40") {
                                                width = 810;
                                                height = 1200;
                                                thumbnailWidth = 112;
                                                thumbnailHeight = 166;
                                                isDefaultTrue = false;
                                                maxVersion = 0;
                                                maxVersionTcid = "";
                                                let widthAndHeight = `${width}x${height}`;
                                                const thumbnailContainerCardStyleDefault = {
                                                    width: thumbnailWidth,
                                                    height: thumbnailHeight + 40,
                                                    marginLeft: '12px',
                                                    marginTop: '12px',
                                                    border: 'solid',
                                                    borderColor: 'lightgreen'
                                                };

                                                if (thumbnail.versions) {
                                                    thumbnail.versions.forEach(version => {
                                                        if (version.default) {

                                                            isDefaultTrue = true;
                                                            if (version.version >= maxVersion) {
                                                                maxVersion = version.version;
                                                                maxVersionTcid = version.tcid;
                                                            }
                                                            let card = (
                                                                <Card style={thumbnailContainerCardStyleDefault}>
                                                                    <a href={`${urlConfig.thumbnailUrlBase}?cid=${version.tcid}&t=thumb${widthAndHeight}&v=${version.version}`}
                                                                       target="_blank" rel="noopener noreferrer">
                                                                        <img id={version.tcid} height={thumbnailHeight}
                                                                             width={thumbnailWidth}
                                                                             alt={`tcid=${version.tcid}`}
                                                                             src={`${urlConfig.thumbnailUrlBase}?cid=${version.tcid}&t=thumb${widthAndHeight}&v=${version.version}`}>
                                                                        </img>
                                                                    </a>
                                                                    <Typography variant={'caption'}
                                                                                style={captionStyle}>
                                                                        {/* {`${thumbnail.aspectRatio},${thumbnail.hasTitle?'With':'Without'} Title,v${thumbnail.version}`} */}
                                                                        {`${thumbnail.language}, v${version.version} `}
                                                                    </Typography>
                                                                </Card>
                                                            );

                                                            MP27X40Array.push(card)
                                                        } else {
                                                            if (version.version >= maxVersion) {
                                                                maxVersion = version.version;
                                                                maxVersionTcid = version.tcid;
                                                            }
                                                        }
                                                    });
                                                    if (isDefaultTrue === false) {
                                                        let card = (
                                                            <Card style={thumbnailContainerCardStyleDefault}>
                                                                <a href={`${urlConfig.thumbnailUrlBase}?cid=${maxVersionTcid}&t=thumb${widthAndHeight}&v=${maxVersion}`}
                                                                   target="_blank" rel="noopener noreferrer">
                                                                    <img id={maxVersionTcid} height={thumbnailHeight}
                                                                         width={thumbnailWidth}
                                                                         alt={`tcid=${maxVersionTcid}`}
                                                                         src={`${urlConfig.thumbnailUrlBase}?cid=${maxVersionTcid}&t=thumb${widthAndHeight}&v=${maxVersion}`}>
                                                                    </img>
                                                                </a>
                                                                <Typography variant={'caption'} style={captionStyle}>
                                                                    {`${thumbnail.language}, v${maxVersion} `}
                                                                </Typography>
                                                            </Card>
                                                        );

                                                        MP27X40Array.push(card)

                                                    }
                                                }
                                            }

                                            if (thumbnail.ratio === "WT16X9") {
                                                width = 800;
                                                height = 450;
                                                thumbnailWidth = 140;
                                                thumbnailHeight = 80;
                                                isDefaultTrue = false;
                                                maxVersion = 0;
                                                maxVersionTcid = "";
                                                let widthAndHeight = `${width}x${height}`;
                                                const thumbnailContainerCardStyleDefault = {
                                                    width: thumbnailWidth,
                                                    height: thumbnailHeight + 40,
                                                    marginLeft: '12px',
                                                    marginTop: '12px',
                                                    border: 'solid',
                                                    borderColor: 'lightgreen'
                                                };

                                                if (thumbnail.versions) {
                                                    thumbnail.versions.forEach(version => {
                                                        if (version.default) {

                                                            isDefaultTrue = true;
                                                            if (version.version >= maxVersion) {
                                                                maxVersion = version.version;
                                                                maxVersionTcid = version.tcid;
                                                            }
                                                            let card = (
                                                                <Card style={thumbnailContainerCardStyleDefault}>
                                                                    <a href={`${urlConfig.thumbnailUrlBase}?cid=${version.tcid}&t=thumb${widthAndHeight}&v=${version.version}`}
                                                                       target="_blank" rel="noopener noreferrer">
                                                                        <img id={version.tcid} height={thumbnailHeight}
                                                                             width={thumbnailWidth}
                                                                             alt={`tcid=${version.tcid}`}
                                                                             src={`${urlConfig.thumbnailUrlBase}?cid=${version.tcid}&t=thumb${widthAndHeight}&v=${version.version}`}>
                                                                        </img>
                                                                    </a>
                                                                    <Typography variant={'caption'}
                                                                                style={captionStyle}>
                                                                        {`${thumbnail.language}, v${version.version} `}
                                                                    </Typography>
                                                                </Card>
                                                            );
                                                            WT16X9Array.push(card);

                                                        } else {
                                                            if (version.version >= maxVersion) {
                                                                maxVersion = version.version;
                                                                maxVersionTcid = version.tcid;
                                                            }
                                                        }
                                                    });
                                                    if (isDefaultTrue === false) {
                                                        let card = (
                                                            <Card style={thumbnailContainerCardStyleDefault}>
                                                                <a href={`${urlConfig.thumbnailUrlBase}?cid=${maxVersionTcid}&t=thumb${widthAndHeight}&v=${maxVersion}`}
                                                                   target="_blank" rel="noopener noreferrer">
                                                                    <img id={maxVersionTcid} height={thumbnailHeight}
                                                                         width={thumbnailWidth}
                                                                         alt={`tcid=${maxVersionTcid}`}
                                                                         src={`${urlConfig.thumbnailUrlBase}?cid=${maxVersionTcid}&t=thumb${widthAndHeight}&v=${maxVersion}`}>
                                                                    </img>
                                                                </a>
                                                                <Typography variant={'caption'} style={captionStyle}>
                                                                    {`${thumbnail.language}, v${maxVersion} `}
                                                                </Typography>
                                                            </Card>
                                                        );

                                                        WT16X9Array.push(card)

                                                    }
                                                }
                                            }

                                            if (thumbnail.ratio === "T16X9") {
                                                width = 800;
                                                height = 450;
                                                thumbnailWidth = 140;
                                                thumbnailHeight = 80;
                                                isDefaultTrue = false;
                                                maxVersion = 0;
                                                maxVersionTcid = "";
                                                let widthAndHeight = `${width}x${height}`;
                                                const thumbnailContainerCardStyleDefault = {
                                                    width: thumbnailWidth,
                                                    height: thumbnailHeight + 40,
                                                    marginLeft: '12px',
                                                    marginTop: '12px',
                                                    border: 'solid',
                                                    borderColor: 'lightgreen'
                                                };

                                                if (thumbnail.versions) {
                                                    thumbnail.versions.forEach(version => {
                                                        if (version.default) {
                                                            isDefaultTrue = true;
                                                            if (version.version >= maxVersion) {
                                                                maxVersion = version.version;
                                                                maxVersionTcid = version.tcid;
                                                            }
                                                            let card = (
                                                                <Card style={thumbnailContainerCardStyleDefault}>
                                                                    <a href={`${urlConfig.thumbnailUrlBase}?cid=${version.tcid}&t=thumb${widthAndHeight}&v=${version.version}`}
                                                                       target="_blank" rel="noopener noreferrer">
                                                                        <img id={version.tcid} height={thumbnailHeight}
                                                                             width={thumbnailWidth}
                                                                             alt={`tcid=${version.tcid}`}
                                                                             src={`${urlConfig.thumbnailUrlBase}?cid=${version.tcid}&t=thumb${widthAndHeight}&v=${version.version}`}>
                                                                        </img>
                                                                    </a>
                                                                    <Typography variant={'caption'}
                                                                                style={captionStyle}>
                                                                        {`${thumbnail.language}, v${version.version} `}
                                                                    </Typography>
                                                                </Card>
                                                            );

                                                            T16X9Array.push(card);
                                                        } else {
                                                            if (version.version >= maxVersion) {
                                                                maxVersion = version.version;
                                                                maxVersionTcid = version.tcid;
                                                            }
                                                        }
                                                    });
                                                    if (isDefaultTrue === false) {
                                                        let card = (
                                                            <Card style={thumbnailContainerCardStyleDefault}>
                                                                <a href={`${urlConfig.thumbnailUrlBase}?cid=${maxVersionTcid}&t=thumb${widthAndHeight}&v=${maxVersion}`}
                                                                   target="_blank" rel="noopener noreferrer">
                                                                    <img id={maxVersionTcid} height={thumbnailHeight}
                                                                         width={thumbnailWidth}
                                                                         alt={`tcid=${maxVersionTcid}`}
                                                                         src={`${urlConfig.thumbnailUrlBase}?cid=${maxVersionTcid}&t=thumb${widthAndHeight}&v=${maxVersion}`}>
                                                                    </img>
                                                                </a>
                                                                <Typography variant={'caption'} style={captionStyle}>
                                                                    {`${thumbnail.language}, v${maxVersion} `}
                                                                </Typography>
                                                            </Card>
                                                        );

                                                        T16X9Array.push(card)

                                                    }
                                                }
                                            }

                                        });
                                        currentRow.push(key);
                                        currentRow.push(MP27X40Array);
                                        currentRow.push(T4X3Array);
                                        currentRow.push(WT4X3Array);
                                        currentRow.push(T16X9Array);
                                        currentRow.push(WT16X9Array);
                                        flatResponse.push(currentRow);
                                    }
                                });
                                rows = rows.concat(flatResponse)
                            }
                        }
                    })
            }
            return rows;
        }
    };

    render() {

        const options = {
            filterType: 'dropdown',
            pagination: true,
            selectableRows: 'none',
            print: false,
            responsive: 'scrollable'
        };

        const {classes, theme} = this.props;

        const containerStyle = {
            minHeight: '650px',
            paddingTop: '10px'
        };

        const contentIdInputStyle = {};

        const buttonIconStyle = {
            marginRight: theme.spacing(1),
        };

        const captionStyle = {};

        this.columns = [
            {
                name: "Cid",
                options: {
                    filter: false,
                }
            },
            {
                name: "Movie Poster 27x40"
            },
            {
                name: "4x3 With Title"
            },
            {
                name: "4x3 Without Title"
            },
            {
                name: "16x9 With Title"
            },
            {
                name: "16x9 Without Title"
            }
        ];

        return (
            <Paper style={containerStyle}>
                <Grid container spacing={8}
                      direction="row"
                      alignItems="center"
                      justify="center">


                    <Grid item sm={3}>
                        <TextField style={contentIdInputStyle}
                                   fullWidth
                                   multiline
                                   rowsMax="6"
                                   rows="3"
                                   variant="outlined"
                                   label="Enter Playlist IDs"
                                   value={this.state.playlistId}
                                   onChange={this.handleChange('playlistId')}
                        />
                    </Grid>


                    <Grid item sm={3}>
                        <TextField style={contentIdInputStyle}
                                   fullWidth
                                   multiline
                                   rowsMax="6"
                                   rows="3"
                                   variant="outlined"
                                   label="Enter CIDs"
                                   value={this.state.cid}
                                   onChange={this.handleChange('cid')}
                        />
                    </Grid>


                    <Grid item sm={1}>
                        {
                            this.state.playlistId.trim() === '' && this.state.cid.trim() === ''
                                ?
                                <Button variant="contained" color="primary" onClick={this.findThumbnails.bind(this)}
                                        disabled>
                                    <SearchIcon style={buttonIconStyle}/>
                                    Show Thumbnails
                                </Button>
                                :
                                <Button variant="contained" color="primary" onClick={this.findThumbnails.bind(this)}>
                                    <SearchIcon style={buttonIconStyle}/>
                                    Show Thumbnails
                                </Button>
                        }

                    </Grid>

                </Grid>

                {this.state.thumbnailData && Object.keys(this.state.thumbnailData).length > 0
                    ?
                    <Grid container spacing={0}
                          direction="row"
                          justify="space-around"
                          alignItems="center">

                        <Grid item sm={12}>

                            <MUIDataTable
                                title={"Search Results"}
                                data={this.state.thumbnailData}
                                columns={this.columns}
                                options={options}
                            />
                        </Grid>
                    </Grid>
                    : null
                }
                {
                    this.state.showLoading
                        ?
                        <div style={{textAlign: 'center'}}>
                            <CircularProgress className={classes.progress} color="secondary"/>
                        </div>
                        : null
                }

            </Paper>
        )
    }

}

const ThumbnailDisplay = withSnackbar(ThumbnailPrint);
export default withStyles(styles, {withTheme: true})(ThumbnailDisplay);